import React from 'react';

const VisaLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 26" style={{ height: 24 }}>
    <rect width="80" height="26" rx="4" fill="white"/>
    <text x="8" y="20" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="22" fill="#1A1F71" letterSpacing="1">VISA</text>
  </svg>
);

const MastercardLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 24" style={{ height: 32 }}>
    <rect width="38" height="24" rx="4" fill="#f5f5f5"/>
    <circle cx="15" cy="12" r="7" fill="#EB001B"/>
    <circle cx="23" cy="12" r="7" fill="#F79E1B"/>
    <path d="M19 6.8a7 7 0 0 1 0 10.4A7 7 0 0 1 19 6.8z" fill="#FF5F00"/>
  </svg>
);


export default function OfertaPage() {
  return (
    <div style={{
      maxWidth: 800,
      margin: '0 auto',
      padding: '40px 24px 80px',
      fontFamily: "'Inter', sans-serif",
      color: '#0d0d0b',
      lineHeight: 1.7,
    }}>
      <h1 style={{
        fontFamily: "'Fraunces', serif",
        fontSize: 32,
        fontWeight: 500,
        marginBottom: 8,
        color: '#0d0d0b',
      }}>
        Договір публічної оферти
      </h1>
      <p style={{ color: '#6b6560', fontSize: 14, marginBottom: 40 }}>
        Ресторан «Околиця» — okolitsya-lentochka.com.ua
      </p>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>1. Загальні положення</h2>
        <p>1.1. Справжня оферта є офіційною пропозицією <strong>Фізичної особи-підприємця Візнюк Олени Василівни</strong> (далі — «Продавець»), укласти Договір купівлі-продажу товарів дистанційним способом через Інтернет-сайт, розміщений за адресою: <a href="https://okolitsya-lentochka.com.ua" style={linkStyle}>okolitsya-lentochka.com.ua</a> (далі — «Інтернет-сайт»).</p>
        <p>1.2. Моментом повного та безумовного прийняття Покупцем пропозиції Продавця (акцептом) вважається факт оплати Покупцем замовлення на умовах цього Договору, у строки та за цінами, вказаними на Інтернет-сайті Продавця.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>2. Поняття та визначення</h2>
        <p>2.1. У цій оферті наведені нижче терміни мають такі значення:</p>
        <ul style={ulStyle}>
          <li><strong>«Товар»</strong> — матеріальний об'єкт, предмет, інформація про який розміщена на Сайті.</li>
          <li><strong>«Інтернет-магазин»</strong> — засіб для подання або реалізації товару шляхом здійснення електронної угоди відповідно до Закону України «Про електронну комерцію».</li>
          <li><strong>«Продавець»</strong> — ФОП Візнюк Олена Василівна, що реалізує товари/послуги, представлені на Інтернет-сайті.</li>
          <li><strong>«Покупець»</strong> — фізична особа, яка уклала з Продавцем Договір на умовах, викладених нижче.</li>
          <li><strong>«Замовлення»</strong> — вибір окремих позицій із переліку товарів/послуг, зазначених Покупцем під час розміщення замовлення та проведення оплати.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>3. Предмет Договору</h2>
        <p>3.1. Продавець зобов'язується передати у власність Покупця Товар, а Покупець зобов'язується сплатити та прийняти Товар на умовах цього Договору.</p>
        <p>Цей Договір регулює купівлю-продаж товарів в Інтернет-магазині, в тому числі:</p>
        <ul style={ulStyle}>
          <li>добровільний вибір Покупцем товарів в Інтернет-магазині;</li>
          <li>самостійне оформлення Покупцем замовлення;</li>
          <li>оплата Покупцем замовлення;</li>
          <li>обробка та доставка замовлення Покупцю.</li>
        </ul>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>4. Порядок оформлення замовлення</h2>
        <p>4.1. Покупець має право оформити замовлення на будь-який товар, представлений на Сайті та наявний.</p>
        <p>4.2. Кожна позиція може бути представлена на замовлення в будь-якій кількості.</p>
        <p>4.3. За відсутності товару Продавець зобов'язаний повідомити Покупця (по телефону або через електронну пошту).</p>
        <p>4.4. За відсутності товару Покупець має право замінити його товаром-аналогом або відмовитися від замовлення.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>5. Порядок оплати замовлення</h2>
        <p><strong>Накладним платежем:</strong></p>
        <p>5.1. Оплата здійснюється за фактом отримання товару у відділенні транспортних компаній за готівку в гривнях.</p>
        <p>5.2. При ненадходженні коштів Інтернет-магазин залишає за собою право анулювати замовлення.</p>
        <p><strong>Оплата через систему NovaPay:</strong></p>
        <p>5.3. Оплата здійснюється на сайті у момент оформлення замовлення.</p>
        <p>5.4. При ненадходженні коштів Інтернет-магазин залишає за собою право анулювати замовлення.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>6. Умови доставки замовлення</h2>
        <p>6.1. Доставка товарів здійснюється до складів транспортних компаній, а також може здійснюватися кур'єром за адресою, вказаною при оформленні замовлення.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>7. Права та обов'язки сторін</h2>
        <p>7.1. Продавець має право в односторонньому порядку призупинити надання послуг у разі порушення Покупцем умов цього договору.</p>
        <p>7.2. Покупець зобов'язаний своєчасно оплатити та отримати замовлення на умовах цього договору.</p>
        <p>7.3. Покупець має право оформити замовлення, оформити електронний договір та вимагати від Продавця виконання умов Договору.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>8. Відповідальність сторін</h2>
        <p>8.1. Сторони несуть відповідальність за невиконання або неналежне виконання умов цього договору відповідно до чинного законодавства України.</p>
        <p>8.2. Продавець не несе відповідальності за: змінений виробником зовнішній вигляд Товару; незначну невідповідність кольорової гами; затримку у наданні послуг з причин поза сферою його контролю.</p>
        <p>8.3. У разі настання обставин непереборної сили сторони звільняються від виконання умов цього договору.</p>
        <p>8.4. Сторони докладають максимум зусиль для вирішення будь-яких суперечностей шляхом переговорів.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>9. Інші умови</h2>
        <p>9.1. Інтернет-магазин залишає за собою право вносити зміни до цього договору за умови попередньої публікації на сайті.</p>
        <p>9.2. Оплата Покупцем оформленого замовлення означає повну згоду з умовами цього договору.</p>
        <p>9.3. Інформація, що надається Покупцем, є конфіденційною та використовується виключно з метою обробки замовлення.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>10. Порядок повернення товару</h2>
        <p>10.1. Повернення товару здійснюється відповідно до чинного законодавства України.</p>
        <p>10.2. Повернення товару здійснюється за рахунок Покупця.</p>
        <p>10.3. При поверненні товару належної якості Інтернет-магазин повертає сплачену суму за вирахуванням витрат на доставку.</p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2 style={h2Style}>11. Строк дії договору</h2>
        <p>11.1. Електронний договір вважається укладеним з моменту отримання відповіді про прийняття пропозиції відповідно до ст. 11 Закону України «Про електронну комерцію».</p>
        <p>11.2. Договір може бути розірваний за взаємною згодою сторін до фактичної доставки товару шляхом повернення коштів.</p>
      </section>

      <section style={{
        marginTop: 40,
        padding: '28px',
        background: '#f9f6f1',
        borderRadius: 16,
        border: '1px solid #e8ddd0',
      }}>
        <h2 style={{ ...h2Style, marginTop: 0 }}>Реквізити Продавця</h2>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
          <tbody>
            {[
              ['Продавець', 'Фізична особа-підприємець Візнюк Олена Василівна'],
              ['РНОКПП (ІПН)', '3252517903'],
              ['Місцезнаходження', 'Україна, 23222, Вінницька обл., Вінницький р-н, село Якушинці, вул. Хмельницького Б., будинок 94 В'],
              ['Дата та номер запису в ЄДР', '09.08.2025, №2001490010005009599'],
              ['Рахунок отримувача (IBAN)', 'UA273052990000026009026109581'],
              ['Назва банку', 'ТОВ «НоваПей»'],
              ['Телефон', '+380 (96) 736-51-96'],
              ['Сайт', 'okolitsya-lentochka.com.ua'],
            ].map(([label, value]) => (
              <tr key={label} style={{ borderBottom: '1px solid #e8ddd0' }}>
                <td style={{ padding: '10px 0', color: '#6b6560', width: '40%', verticalAlign: 'top' }}>{label}</td>
                <td style={{ padding: '10px 0', fontWeight: 500 }}>{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <div style={{ marginTop: 40, display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <VisaLogo />
        <MastercardLogo />
      </div>
    </div>
  );
}

const h2Style = {
  fontFamily: "'Fraunces', serif",
  fontSize: 20,
  fontWeight: 500,
  marginBottom: 12,
  marginTop: 0,
  color: '#0d0d0b',
};

const ulStyle = {
  paddingLeft: 20,
  marginTop: 8,
};

const linkStyle = {
  color: '#8b6914',
  textDecoration: 'underline',
};
